import { render, staticRenderFns } from "./Letter_Literature.vue?vue&type=template&id=7b95bf5b&scoped=true"
import script from "./Letter_Literature.vue?vue&type=script&lang=js"
export * from "./Letter_Literature.vue?vue&type=script&lang=js"
import style0 from "./Letter_Literature.vue?vue&type=style&index=0&id=7b95bf5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b95bf5b",
  null
  
)

export default component.exports